export default __webpack_public_path__ + "static/media/aboutBG.178cacd2.jpg";